<template><div :class="(stylev2) ? 'container-field-stylev2' : ''"> 
    <template v-if="kind.startsWith('detail')">
        <doc-text-field
          :initial_error="false"
          :error="calculedErrorDetail || metadata_error"
          :kind="kind"
          :readonly="readonly"
          :label="fieldText"
          :required="required"
          @focus="selectLabel({ label: fieldKey })"
          :value="detail_value(that['metadata_detail_'+fieldCheck[0]],fieldKey)"
          :disabled="true"
          @input="emitInput"
        ></doc-text-field>
    </template>
    <template v-else>
        <v-row no-gutters>
            <v-col cols="3"  class="table-button" v-if="show_calc_btn()">
                <v-btn
                    color="primary"
                    :disabled="false"
                    @click="calc_vat_field()"
                    icon
                    >
                    <v-icon v-once>mdi-calculator-variant</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="2"  class="table-button" :class="(stylev2) ? 'btn-invoice-calc-total' : ''" v-if="show_calc_total_btn">
                <v-btn
                    small
                    color="primary"
                    @click="calc_total_btn()"
                    icon
                    >
                    <v-icon v-once>mdi-calculator-variant</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="2"  class="table-button" :class="(stylev2) ? 'btn-invoice-calc-ret' : ''" v-if="show_calc_retention_btn">
                <v-btn
                    small
                    color="primary"
                    @click="calc_retention_btn()"
                    icon
                    >
                    <v-icon v-once>mdi-calculator-variant</v-icon>
                </v-btn>
            </v-col>
            <v-col>
                <doc-text-field
                    :initial_error="initial_error"
                    :error="calculedError || metadata_error"
                    :kind="kind"
                    :readonly="readonly"
                    :label="fieldText"
                    :required="required"
                    @input="setAccount()"
                    @focus="selectLabel({ label: fieldKey })"
                    v-model="that['metadata_'+fieldKey]"
                    :disabled="is_einvoice || permission.is_readonly|| (currentDocument.forced_move && !editableForcedMove) || (currentDocument && (['pending','running'].includes(currentDocument.async_job_state) || ['pending_connect','accounting_aplifisa_fiscal', 'accounting_invoice'].includes(currentDocument.state)))"
                    :num_digits="num_digits"
                    :items='items'
                    @get-values="getValues"
                    @reset-items="resetItems"
                    :stylev2="stylev2"
                ></doc-text-field>
            </v-col>
        </v-row>
    </template>   
    <div class="error--text" v-if="initial_error && fieldKey == 'other_amounts'">No tiene cuenta de suplidos asociada</div>
    <div class="error--text" v-if="balance && ['total_amount'].includes(fieldKey)">Descuadre: {{balance}} <v-btn v-if="show_calc_total_ex0" outlined class="btn-invoice-stylev2" @click="calc_mismatch_to_ex0">Descuadre a 0% EX</v-btn></div>
    <div class="error--text" v-if="balance && !this.got_feature('feature_tolerancy_not_applies_total_amount') && ['total_amount'].includes(fieldKey)">(Tolerancia configurable en el conector)</div></div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { createHelpers,mapFields } from 'vuex-map-fields';
    import {mapFieldsMetadata,vuexPrefix} from "../store/vuex_utils"
    import { STANDARD_LABELS_CLIENT} from "../store/constants";
    import DocTextField from "./DocTextField.vue"
    import {round} from '../utils'
    import { isTotalAmountCorrect, Amounts } from "../modules/invoices/domain/Invoice"
    import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"

    export default {
        name:'MetadataField',
        components:{
            DocTextField
        },
        props:{
            fieldKey:String,
            fieldCheck:{
                type:Array,
                default: function(){return []},
            },
            fieldText:String,
            readonly:Boolean,
            required: Boolean,
            metadata:Object,
            kind:{
                type:String,
                default: 'text', //account, number, text
            },
            tabs:Array,
            initial_error:{
                type:Boolean,
                default: false, //account, number, text
            },
            metadata_error: {
                type:Boolean,
                default:false
            },
            editableForcedMove:{
                type:Boolean,
                default: false, 
            },
            fillAccount:{
                type:[String, Boolean],
                default: false
            },
            num_digits: {
                type: [Number, Boolean],
                default: false
            },
            items: {
                type: Array,
                default: function () {
                        return [];
                    },
                required: false
            },
            stylev2: {              
                type:Boolean,
                default: false,
            },            
        },
        methods:{
            setAccount(value){
                if(this.fillAccount){
                    if (this['metadata_base_'+this.fillAccount]!="" || this['metadata_'+this.fillAccount]!=""){
                        if(!this['metadata_account_'+this.fillAccount] || this['metadata_account_'+this.fillAccount]==""){
                            if(this.currentDocument.kind=='in_invoice'){
                                if(this.currentDocument.supplierdb_info && this.currentDocument.supplierdb_info.expens_accounts)
                                    this['metadata_account_'+this.fillAccount]=this.currentDocument.supplierdb_info.expens_accounts[0]
                            }
                            else{
                                if(this.currentDocument.customerdb_info.income_accounts)
                                    this['metadata_account_'+this.fillAccount]=this.currentDocument.customerdb_info.income_accounts[0]
                            }
                        }
                    }
                    if ((!this['metadata_base_'+this.fillAccount] || this['metadata_base_'+this.fillAccount]=="")
                     && (!this['metadata_'+this.fillAccount] || this['metadata_'+this.fillAccount]=="")){
                        this['metadata_account_'+this.fillAccount]=''
                    }
                }
                this.emitInput()
            },
            myParseFloat(e){
                if(e)
                    return parseFloat(e.toString().replace(',','.'))
                else
                    return e

            },
            concat_account(vat){
                let res = [this.currentDocument.metadata['account_'+vat]]
                for(let i in this.currentDocument.metadata['detail_'+vat]){
                    res.push(parseFloat(this.currentDocument.metadata['detail_'+vat][i]['account_'+vat]))
                }
                return res.join(',')
            },
            truncate(text, length, clamp){
                clamp = clamp || '...';
                return text.length > length ? text.slice(0, length) + clamp : text;
            },
            detail_value(lines,field){
                if(this.kind=='detail_account'){
                    return (this.currentDocument.metadata['detail_'+field].length+1).toString() + ' cuentas' 
                }
                return round(this.sum(lines,field),2)
            },
            sum(lines,field){
                let sum = this.myParseFloat(this['metadata_'+field])
                for(let i in lines){
                    sum = sum + this.myParseFloat(lines[i][field])
                }
                return sum
            },
            calc_vat_field() {
                
                let vat = this.fieldCheck[0].replace('base_','');
                let coef = this.fieldCheck[1];
                let cuota = this.myParseFloat(this['metadata_'+vat]);
                let base = this.myParseFloat(this['metadata_base_'+vat]);
                if (cuota && coef != 0 && this.is_base) {
                    this['metadata_base_'+vat] = Math.round((cuota/coef) * 100) / 100;
                }
                else if (base && !this.is_base) {
                    this['metadata_'+vat] = Math.round((base*coef) * 100) / 100;
                }
            },
            show_calc_btn() {
                let complementFieldKey = '';
                if (this.fieldKey.includes('base')) {
                    complementFieldKey = this.fieldKey.replace('base_','');
                }
                else {
                    complementFieldKey = 'base_' + this.fieldKey;
                }
                return this.fieldCheck.length>0  && this['metadata_'+this.fieldKey] != '0' && ((this['metadata_'+complementFieldKey] && !this['metadata_'+this.fieldKey]) || (this['metadata_'+complementFieldKey] && this['metadata_'+this.fieldKey] &&  this.calculedError));
            },
            calc_total_btn(){
                this['metadata_'+this.fieldKey] = this.calcTotal
            },
            calc_retention_btn(){
                this['metadata_'+this.fieldKey] = round(Math.abs(this.sumaBasesCuotas[2])*Math.abs(this.myParseFloat(this['metadata_retention_type']))/100.0,2)
            },
            ...mapActions({
                selectLabel: "documents/selectLabel",
            }),
            getValues(params) {
                this.$emit('get-values', params);
            },
            resetItems(params) {
                this.$emit('reset-items', params);
            },
            calc_mismatch_to_ex0() {
                if  (this.currentCompany && this.currentCompany.tax_type && this.currentCompany.tax_type.includes('iva')) {
                    if ('metadata_base_vat_0' in this) {
                        if (this['metadata_base_vat_0']) {
                            this['metadata_base_vat_0'] = Math.round((this.myParseFloat(this['metadata_base_vat_0']) + this.balance)*100)/100;                            
                        } else {
                            this['metadata_base_vat_0'] = this.balance;
                            this['metadata_vat_0'] = 0;                        
                        }
                    }
                }
                else if  (this.currentCompany && this.currentCompany.tax_type && this.currentCompany.tax_type.includes('igic')) {
                    if ('metadata_base_igic_0' in this) {
                        if (this['metadata_base_igic_0']){
                            this['metadata_base_igic_0'] = Math.round((this.myParseFloat(this['metadata_base_igic_0']) + this.balance)*100)/100;                            

                        } else {
                            this['metadata_base_igic_0'] = this.balance;
                            this['metadata_igic_0'] = 0;                        
                        }
                    }
                }
            },
            emitInput() {
                this.$emit('input')
            },
        },
        computed:{
            ...mapGetters({
                currentDocument: "documents/currentDocument",
                currentCompany:"getCurrentCompany",
                userData: "me/userData",
                permission: 'permissions/permission',
                got_feature:'got_feature',
                inv_metadata:'documents/metadata',

            }), 
            that(){
                return this
            },
            is_einvoice(){
                if (this.currentDocument.static_invoice && !this.fieldKey.includes('account')){
                    return true
                }
                else{
                    return false
                }
            },
            is_base(){
                return this.fieldKey.includes('base')
            },
            show_calc_total_btn(){
                return this.balance && ['total_amount'].includes(this.fieldKey) && this.userData.available_features.feature_new_calc
            },
            show_calc_retention_btn(){
                return this.required && this.calculedError && ['retention_amount'].includes(this.fieldKey) && this.userData.available_features.feature_new_calc
            },
            show_calc_total_ex0() {
                try {
                    return this.balance && 0 < Math.abs(this.balance) && Math.abs(this.balance) < 0.05 && ['total_amount'].includes(this.fieldKey) && this.userData.available_features.feature_massive_fix_mismatch_ex0
                } catch (e) {
                    return false;
                }                
            },
            typeCheckRet(){
                let type = 'none'
                if (this.currentCompany.check_ret){
                    type = 'checkbox'
                }
                else if((this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'account_move')){
                    type = 'base'
                }
                else if(this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'invoice'){
                    if(this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas){
                        type = 'detail'
                    }
                    else{
                        type = 'base'
                    }
                }
                return type
            },
            calculedError(){
                const tolerancy = this.currentDocument.companydb_info.tolerancy;
                let error=false
                let suma_bases = 0.0
                let suma_cuotas = 0.0
                let suma_ret = 0.0
                let there_is_base = false
                let amounts = new Amounts(this.inv_metadata)

                if(['total_amount','retention_amount','retention_type'].includes(this.fieldKey)){
                    let res = amounts.suma_bases_cuotas(this.fieldKey, this, this.tabs, this.typeCheckRet);
                    suma_bases = res[0]
                    suma_cuotas = res[1]
                    suma_ret = res[2]
                    there_is_base = res[3]
                    error = amounts.error_total_amount_retention(this.fieldKey,this, there_is_base, tolerancy, isTotalAmountCorrect, suma_ret, this.balance, this.userData, this.required);
                }

                else if(this.fieldKey.startsWith('base_') && this['metadata_'+this.fieldKey] && this.fieldCheck.length>0){
                    if((!Boolean(this['metadata_'+this.fieldCheck[0]]) && this['metadata_'+this.fieldCheck[0]]!==0) || round(this.myParseFloat(this['metadata_'+this.fieldKey])*this.fieldCheck[1]) > round(this.myParseFloat(this['metadata_'+this.fieldCheck[0]]))+tolerancy
                    || round(this.myParseFloat(this['metadata_'+this.fieldKey])*this.fieldCheck[1]) < round(this.myParseFloat(this['metadata_'+this.fieldCheck[0]])-tolerancy)){
                        error=true
                    }
                }
                else if(!this.fieldKey.startsWith('base_') && !this.fieldKey.startsWith('ret_base_') && this['metadata_'+this.fieldKey] && this.fieldCheck.length>0){
                    
                    if(!Boolean(this['metadata_'+this.fieldCheck[0]]) || round(this.myParseFloat(this['metadata_'+this.fieldCheck[0]])*this.fieldCheck[1]) > round(this.myParseFloat(this['metadata_'+this.fieldKey])+tolerancy)
                    || round(this.myParseFloat(this['metadata_'+this.fieldCheck[0]])*this.fieldCheck[1]) < round(this.myParseFloat(this['metadata_'+this.fieldKey])-tolerancy)){
                        error=true
                    }
                } else if(this.fieldKey.startsWith('account_')){
                    let auxFieldBaseKey = this['metadata_base_'+this.fieldKey.replace("account_","")]
                    let auxFieldCuotaKey = this['metadata_'+this.fieldKey.replace("account_","")]
                    if ( (!this['metadata_'+this.fieldKey] || this['metadata_'+this.fieldKey] == '') && (
                        (auxFieldBaseKey!=='' && auxFieldBaseKey) || auxFieldCuotaKey!=='' && auxFieldCuotaKey)) {
                            error = this.got_feature('feature_expense_income_type') ? false : true
                        }
                }
                else if(this.fieldKey.startsWith('ret_base_') && this.fieldCheck.length>0){     
                    if(this['metadata_'+this.fieldKey] && !Boolean(this['metadata_'+this.fieldCheck[0]]) || Math.abs(round(this.myParseFloat(this['metadata_'+this.fieldCheck[0]])+this.myParseFloat(this['metadata_'+this.fieldCheck[0]])*this.fieldCheck[1])) < Math.abs(this.myParseFloat(this['metadata_'+this.fieldKey]))) //la base de ret no pot superar base+quota
                    {
                        error=true
                    }
                }
                else if (this.fieldCheck.length > 0) {
                    let auxFieldKey = null;
                    if (this.fieldKey.startsWith('base_')) {
                        auxFieldKey = this['metadata_'+this.fieldKey.replace("base_","")]
                    } else {
                        auxFieldKey = this['metadata_base_'+this.fieldKey]
                    }

                    if (!isNaN(this.that['metadata_'+this.fieldKey]) && isNaN(auxFieldKey)) {
                        error = true;
                    } else if (isNaN(this.that['metadata_'+this.fieldKey]) && !isNaN(auxFieldKey)) {
                        error = true;
                    }
                }
                
                return error;
            },
            calculedErrorDetail(){
                const tolerancy = this.currentDocument.companydb_info.tolerancy;
                if(this.kind=='detail_account'){
                    let res = this['metadata_account_'+this.fieldKey] && this['metadata_account_'+this.fieldKey]!=''
                    let lines = this['metadata_detail_'+this.fieldKey]
                    for(let i in lines){
                        res = res && (lines[i]['account_'+this.fieldKey]!='' && this.currentCompany.num_digits == lines[i]['account_'+this.fieldKey].length && Number.isInteger(Number(lines[i]['account_'+this.fieldKey])));
                    }
                    return !res                     
                }
                let sum_base = this.sum(this['metadata_detail_'+this.fieldCheck[0]], 'base_'+this.fieldCheck[0])
                let sum_cuota = this.sum(this['metadata_detail_'+this.fieldCheck[0]], this.fieldCheck[0])
                return (sum_base*this.fieldCheck[1] > sum_cuota + tolerancy) ||
                       (sum_base*this.fieldCheck[1] < sum_cuota - tolerancy) 
            },
            sumaBasesCuotas(){
                return new Amounts(this.inv_metadata).suma_bases_cuotas(this.fieldKey, this, this.tabs, this.typeCheckRet)
            },
            calcTotal(){
                let check_total_all_decimals = this.got_feature('feature_a3_descuadre_fix') && !['',undefined].includes(this['metadata_retention_amount']) 
                let total = this.sumaBasesCuotas[0] + this.sumaBasesCuotas[1]
                let total_amount = this.myParseFloat(this['metadata_total_amount'])
                if(this['metadata_retention_amount']){
                    if(total>0){
                        if(this.currentCompany.check_ret){
                            total = total - this.myParseFloat(this['metadata_retention_amount'])
                        }else{
                            if(check_total_all_decimals){
                                total = total - this.sumaBasesCuotas[0]*Math.abs(this.myParseFloat(this['metadata_retention_type'])/100)
                            }
                            else{
                                total = total - Math.abs(this.myParseFloat(this['metadata_retention_amount']))
                            }
                        }
                    }
                    else{
                        if(this.currentCompany.check_ret){
                            total = total + this.myParseFloat(this['metadata_retention_amount'])
                        }else{
                            if(check_total_all_decimals){
                                total = total + this.sumaBasesCuotas[0]*Math.abs(this.myParseFloat(this['metadata_retention_type'])/100)
                            }
                            else{
                                total = total + Math.abs(this.myParseFloat(this['metadata_retention_amount']))
                            }
                        }
                    }
                }
                if(this['metadata_other_amounts']){
                    total = total + parseFloat(this['metadata_other_amounts'])
                }
                return round(total,2)
            },
            balance(){
                return round(this['metadata_total_amount']-this.calcTotal)
            },
            ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS_CLIENT.map(x=>x.name),'')),
            ...mapFields('documents',vuexPrefix('document_',['kind','state','supplierdb','customerdb'],'document.')),
            ...mapFields('me',vuexPrefix('',['feature_base_retention'],'userData.available_features.')),
            
          
        }
    }
</script>

<style scoped>

    .table-button {
        border-bottom-style:solid;
        border-width: thin;
        border-bottom-color: rgba(0,0,0,.42);
        margin-bottom: -1px;
    }

    .btn-invoice-calc-ret,
    .btn-invoice-calc-total {
        line-height: 18px;        
        border:none;
    }
    .btn-invoice-calc-ret >>> .v-btn,
    .btn-invoice-calc-total >>> .v-btn{
        height:20px !important;
        width:20px !important;
        padding:0px !important;
    }
    
    .btn-invoice-calc-ret >>> .v-icon,
    .btn-invoice-calc-total >>> .v-icon {
        font-size:18px;  
        height: 20px;
        width: 20px;
    }

    .container-field-stylev2 .error--text {
        font-size:12px;
    }

    .btn-invoice-stylev2{
        height:19px !important;
        border-color: rgb(102, 51, 153);
        color: rgb(102, 51, 153);
        border-radius:5px;
        font-size:11px;        
        text-transform: none;
        font-weight: 300;
        letter-spacing: 0;
        padding:0px 5px 0px 5px !important;
    }
</style>
